<template>
  <layout-default class="page-works">
    <layout-introduction
      title="Works"
      subtitle="ワークス"
      :fullscreen="false"
    />

    <div class="box box--wrapper">
      <div class="box-title">
        <h2>WORKS & PROJECTS</h2>
      </div>
      <div class="box-content text--center">
        <works-projects />
      </div>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from '@/components/layouts/default/Layout';
import LayoutIntroduction from '@/components/layouts/common/Introduction';
import WorksProjects from '../common/Projects';

export default {
  metaInfo: {
    title: 'Works - Jerome Dupuis Portfolio'
  },
  components: {
    LayoutDefault,
    LayoutIntroduction,
    WorksProjects
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/works/Works.vue